/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getStatus.defs'
export { main as default } from './getStatus.defs'
